export interface Option {
    readonly value: string;
    readonly label: string;
    readonly isFixed?: boolean;
    readonly isDisabled?: boolean;
}

export interface GroupedOption {
    readonly label: string;
    readonly options: readonly Option[];
}

export const ActivityStartDateOptions: readonly Option[] = [
    { value: 'next7StartDays', label: 'Daily, next 7 days' },
    { value: 'prev7StartDays', label: 'Daily, previous 7 days' },
    { value: 'next12StartWeeks', label: 'Weekly, next 12 weeks' },
    { value: 'prev12StartWeeks', label: 'Weekly, previous 12 weeks' },
    { value: 'next12StartMonths', label: 'Monthly, next 12 months' },
    { value: 'prev12StartMonths', label: 'Monthly, previous 12 months' },
];

export const ActivityFinishDateOptions: readonly Option[] = [
    { value: 'next7FinishDays', label: 'Daily, next 7 days' },
    { value: 'prev7FinishDays', label: 'Daily, previous 7 days' },
    { value: 'next12FinishWeeks', label: 'Weekly, next 12 weeks' },
    { value: 'prev12FinishWeeks', label: 'Weekly, previous 12 weeks' },
    { value: 'next12FinishMonths', label: 'Monthly, next 12 months' },
    { value: 'prev12FinishMonths', label: 'Monthly, previous 12 months' },
];

export const wbsOptions: readonly Option[] = [
    { value: 'wbsLevel1', label: 'WBS Level 1' },
    { value: 'wbsLevel2', label: 'WBS Level 2' },
    { value: 'wbsLevel3', label: 'WBS Level 3' },
    { value: 'wbsLevel4', label: 'WBS Level 4' },
    { value: 'parentName', label: 'WBS Parent' },
    { value: 'grandParentName', label: 'WBS Grandparent' },
];

const PRIMARY_GROUP_ACTIVITY_CODE_GROUP: Option = { label: 'Activity Code Group', value: 'activityCodeValueGroup' };

export const groupedOptionsBaseList: readonly (GroupedOption | Option)[] = [
    { label: 'Tag', value: 'tagList' },
    { label: 'Resource Name', value: 'resourceNameList' },
    { label: 'Assignee', value: 'assignee' },
    { label: 'Cluster Name', value: 'cluster' },
    PRIMARY_GROUP_ACTIVITY_CODE_GROUP,
    {
        label: 'WBS',
        options: wbsOptions,
    },
    {
        label: 'Activity Start Date',
        options: ActivityStartDateOptions,
    },
    {
        label: 'Activity Finish Date',
        options: ActivityFinishDateOptions,
    },
];

export const secondaryGroupActivityCodeOption = { label: 'Activity Code', value: 'activityCodeValueName' };
export const ACTIVITY_CODE_GROUP_VALUE = PRIMARY_GROUP_ACTIVITY_CODE_GROUP.value;
